import './EmailTemplateMetadataTab.scss';

import { capitalize } from '@sonar-software/sonar-ts-lib';
import { CodeHighlight } from '@ui/general';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { usePeriscopeMetadata } from '@hooks';

import { MetadataContainer, MetadataEntry } from '@periscopes/general/metadata';
import { PeriscopeSfEmailTemplateMetadata, SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useMemo } from 'react';

export interface EmailTemplateMetadataTabProps {
	index: number;
	sonarObjectId: number;
}

export const EmailTemplateMetadataTab: React.FC<EmailTemplateMetadataTabProps> = ({ index, sonarObjectId }) => {
	const { loading, metadata } = usePeriscopeMetadata<PeriscopeSfEmailTemplateMetadata>(
		sonarObjectId,
		SonarObjectType.SalesforceEmailTemplate
	);

	const metadataEntries = useMemo(() => {
		if (!metadata) {
			return [];
		}

		const entries: MetadataEntry[] = [
			{
				label: COPY_SPECIFIC.TEMPLATE_TYPE,
				type: 'string',
				value: capitalize(metadata.templateType)
			},
			{
				label: COPY_SPECIFIC.AVAILABLE_FOR_USE,
				type: 'boolean',
				value: metadata.availableForUse
			},
			{
				label: COPY_SPECIFIC.FOLDER,
				type: 'string',
				value: metadata.folder
			}
		];

		return entries;
	}, [ metadata ]);

	if (loading) {
		return <LoadingSpinner spinning />;
	}

	const subjectCode = metadata?.subject?.code ?? '';
	const subjectRefs = metadata?.subject?.codeReferences ?? [];
	const bodyCode = metadata?.body?.code ?? '';
	const bodyRefs = metadata?.body?.codeReferences ?? [];

	return (
		<div className='email-template-metadata'>
			<MetadataContainer
				entries={ metadataEntries }
				title={ COPY_SPECIFIC.EMAIL_TEMPLATE_INFORMATION } />
			<b>{ COPY_SPECIFIC.SUBJECT }</b>
			<CodeHighlight
				code={ subjectCode }
				codeReferences={ subjectRefs }
				index={ index } />
			<b>{ COPY_SPECIFIC.BODY_PLAIN_TEXT_PREVIEW }</b>
			<CodeHighlight
				code={ bodyCode }
				codeReferences={ bodyRefs }
				index={ index } />
		</div>
	);
};
